module.exports = __webpack_public_path__ + "static/img/5.2fe46b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/5.png
// module id = /EfG
// module chunks = 0